// extracted by mini-css-extract-plugin
export default {"pdf":"fileviewer_pdf__lrRmf","image":"fileviewer_image__SatjO","unknownType":"fileviewer_unknownType__f8hKg"};